import {
  Module,
  VuexModule,
  MutationAction,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import { RouteData } from '@/api/Wordpress';
import { Wordpress } from '@/api';

@Module({
  name: 'RouterModule',
  namespaced: true,
})
export default class RouterModule extends VuexModule {
  ready: boolean = false;

  routes: any[] = [];

  routeData: Map<string, RouteData> = new Map();

  @Mutation
  setReady() {
    this.ready = true;
  }

  @Mutation
  setRoutes(routes: any[]) {
    this.routes = routes;
  }

  @Action({ rawError: true })
  async getPage(slug: string): Promise<RouteData> {
    try {
      let routeData = this.routeData.get(slug);
      if (!routeData) {
        routeData = await Wordpress.getRouteData(slug);
        this.routeData.set(slug, routeData);
      }
      return routeData;
    } catch (e) {
      throw e;
    }
  }

  @Action({ rawError: true })
  async getHome(): Promise<RouteData> {
    try {
      let homeData = this.routeData.get('home');
      if (!homeData) {
        homeData = await Wordpress.getHomeData();
        this.routeData.set('home', homeData);
      }
      return homeData;
    } catch (e) {
      throw e;
    }
  }

  @Action({ rawError: true })
  async getRoutes() {
    try {
      const response = await Wordpress.getRoutes();
      this.setRoutes(response.routes);
    } catch (e) {
      throw e;
    }
  }

  @Action
  async init() {
    try {
      await this.getRoutes();
    } catch {
      // no comment
    } finally {
      this.setReady();
    }
  }
}
